import {CnpjPipe} from '../pipes/cnpj.pipe';

export class CnpjUtils {

  static normalize(value: string): string {
    if (!value) { return ''; }
    return value
      .replace(/[.\-/\s]/g, '')
      .toUpperCase()
      .trim();
  }

  static format(value: string): string {
    const normalizedValue = this.normalize(value);
    return new CnpjPipe().transform(normalizedValue) || value;
  }
}
